import lib from './lib';
var slLib = lib.init(window),
    doc = slLib.win.document,
    documentSupport = slLib.getDocumentSupport(),
    SVG_BBOX_CORRECTION = documentSupport.isWebKit ? 0 : 4.5;

function ContainerManager(a, b, c) {
  var d;
  c = 5 < c ? c : 5, c = 20 > c ? c : 20, this.maxContainers = c, this.first = null, this.last = null, this.containers = {}, this.length = 0, this.rootNode = a, b && (d = doc.createElementNS('http://www.w3.org/2000/svg', 'svg'), d.setAttributeNS('http://www.w3.org/2000/svg', 'xlink', 'http://www.w3.org/1999/xlink'), d.setAttributeNS('http://www.w3.org/2000/svg', 'height', '0'), d.setAttributeNS('http://www.w3.org/2000/svg', 'width', '0'), this.svgRoot = d, this.rootNode.appendChild(d));
}

ContainerManager.prototype.get = function (a) {
  var b,
      c,
      d,
      e = this.containers,
      f = this.length,
      g = this.maxContainers,
      h = '';

  for (c in slLib.supportedStyle) {
    void 0 !== a[c] && (h += slLib.supportedStyle[c] + ':' + a[c] + ';');
  }

  if (!h) return !1;
  if (d = e[h]) this.first !== d && (d.prev && (d.prev.next = d.next), d.next && (d.next.prev = d.prev), d.next = this.first, d.next.prev = d, this.last === d && (this.last = d.prev), d.prev = null, this.first = d);else {
    if (f >= g) for (b = f - g + 1; b--;) {
      this.removeContainer(this.last);
    }
    d = this.addContainer(h);
  }
  return d;
}, ContainerManager.prototype._makeDivNode = function (a) {
  var b,
      c = a.keyStr;
  a.node || (a.node = doc.createElement('div'), a.node.className = 'fusioncharts-div', this.rootNode.appendChild(a.node)), b = a.node, documentSupport.isIE && !documentSupport.hasSVG ? b.style.setAttribute('cssText', c) : b.setAttribute('style', c), b.setAttribute('aria-hidden', 'true'), b.setAttribute('role', 'presentation'), b.style.display = 'inline-block', b.innerHTML = slLib.testStrAvg, a.lineHeight = b.offsetHeight, a.avgCharWidth = b.offsetWidth / 3, documentSupport.isBrowserLess ? (!a.svgText && (a.svgText = doc.createElementNS('http://www.w3.org/2000/svg', 'text'), this.svgRoot.appendChild(b)), b = a.svgText, b.setAttribute('style', c), b.textContent = slLib.testStrAvg, a.lineHeight = b.getBBox().height, a.avgCharWidth = (b.getBBox().width - SVG_BBOX_CORRECTION) / 3, b.textContent = '...', a.ellipsesWidth = b.getBBox().width - SVG_BBOX_CORRECTION, b.textContent = '.', a.dotWidth = b.getBBox().width - SVG_BBOX_CORRECTION) : (b.innerHTML = '...', a.ellipsesWidth = b.offsetWidth, b.innerHTML = '.', a.dotWidth = b.offsetWidth, b.innerHTML = '');
}, ContainerManager.prototype.addContainer = function (a) {
  var b;
  return this.containers[a] = b = {
    next: null,
    prev: null,
    node: null,
    ellipsesWidth: 0,
    lineHeight: 0,
    dotWidth: 0,
    avgCharWidth: 4,
    keyStr: a,
    charCache: {}
  }, b.next = this.first, b.next && (b.next.prev = b), this.first = b, this.last || (this.last = b), this.length += 1, b;
}, ContainerManager.prototype.removeContainer = function (a) {
  var b = a.keyStr;
  b && this.length && a && (this.length -= 1, a.prev && (a.prev.next = a.next), a.next && (a.next.prev = a.prev), this.first === a && (this.first = a.next), this.last === a && (this.last = a.prev), a.node && a.node.parentNode.removeChild(a.node), delete this.containers[b]);
}, ContainerManager.prototype.dispose = function () {
  var a,
      b = this.containers;

  for (a in this.maxContainers = null, b) {
    this.removeContainer(b[a]);
  }

  this.rootNode.parentNode.removeChild(this.rootNode), this.rootNode = null, this.first = null, this.last = null;
};
export default ContainerManager;